import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Form, Input, Select, Button, message, InputNumber, Spin } from "antd";
import BackRouteButton from "src/common/components/BackRouteButton";
import Skeleton from "src/common/components/Skeleton";
import { PlusOutlined } from "@ant-design/icons";

const { Option } = Select;

export default ({ createStorehouseInstance, storehouse, profile }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const [preparedCategories, setPreparedCategories] = useState();
  const [category, setCategory] = useState(false);

  const onFinish = async (values) => {
    setLoading(true);
    values.category = {
      id: category._id,
      title: category.title,
    };
    values.type = category.type;
    values.creatorId = profile._id;
    values.sizeOfPack = parseInt(values.sizeOfPack);

    var result = await createStorehouseInstance(values);
    if (result.success) {
      form.resetFields();
      message.success("Type (product/raw material) successfully added!");
      history.goBack();
    } else {
      message.error(result.message || "Failed to add!");
      setLoading(false);
    }
  };

  useEffect(() => {
    if (storehouse) {
      setPreparedCategories([
        ...storehouse.productsCategories,
        ...storehouse.rawMaterialsCategories,
      ]);

      setLoading(false);
    }
  }, [storehouse]);

  useEffect(() => {
    if (category) {
      const displayValue =
        category.type === "rawMaterial" ? "Raw Material" : "Product";
      form.setFieldsValue({
        categoryType: displayValue,
      });
    }
  }, [category, form]);

  if (loading) return <Skeleton />;
  return (
    <div className="common-container">
      <Spin spinning={loading}>
        <BackRouteButton />
        <h4 className="common-title--large">Add Type (Product/Raw Material)</h4>

        <Form
          requiredMark={false}
          layout="vertical"
          form={form}
          onFinish={onFinish}
        >
          <Form.Item
            label="Category (Product/Raw Material)"
            name="categoryId"
            rules={[
              {
                required: true,
                message: "Please select a category (Product/Raw Material)!",
              },
            ]}
          >
            <Select
              placeholder="Select a category (Product/Raw Material)"
              onChange={(value, option) => {
                setCategory(option);
              }}
            >
              {preparedCategories.map((category) => (
                <Option
                  key={category._id}
                  _id={category._id}
                  type={category.type}
                  title={category.title}
                >
                  {category.title}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item label="Category Type" name="categoryType">
            <Input readOnly />
          </Form.Item>
          <Form.Item
            label="Type Name (Product/Raw Material)"
            name="title"
            rules={[
              {
                required: true,
                message: "Please enter the type name (Product/Raw Material)!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item label="Pack Size (if needed)" name="sizeOfPack">
            <InputNumber
              min={0}
              step={1}
              precision={0}
              formatter={(value) => {
                if (value) {
                  return `${value} kg`;
                }
              }}
              parser={(value) => value.replace(/\D/g, "")}
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item>
            <Button htmlType="submit" loading={loading}>
              <PlusOutlined /> Add
            </Button>
          </Form.Item>
        </Form>
      </Spin>
    </div>
  );
};
